import React, { useEffect, useState } from 'react';
import { Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@material-ui/core/styles/styled';
import Container from '@material-ui/core/Container';

const RequestMicrophonePermissions = () => {
  const dispatch = useDispatch();
  const permissionsStep = useSelector(state => state.messageState.permissionStep);
  const [title, setTitle] = useState('Please Wait...');
  const [text, setText] = useState(false);

  useEffect(() => {
    if (permissionsStep !== 'unknown') {
      setTitle("We don't have access to your microphone!");
      setText(true);
    }
  }, [permissionsStep]);

  return (
    <ContainerDiv>
      <LightTitle variant="h4" align="center">
        {title}
      </LightTitle>
      <br />
      {text && <MainText>Please check your microphone permissions on your device to allow access (instructions for chrome <a href="https://support.google.com/chrome/answer/2693767" target="_blank" rel="noopener noreferrer">here</a>), then <a href="">reload</a> this page</MainText>}
      <br />
      {text && <MainText>If you are unable to provide permissions, you cannot proceed using the browser. Please follow instructions sent to you via SMS to join via telephone</MainText>}
    </ContainerDiv>
  );
};

export default RequestMicrophonePermissions;

const ContainerDiv = styled(Container)({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
});

const LightTitle = styled(Typography)({
  fontWeight: 300,
  paddingTop: 15,
  paddingBottom: 15,
});

const MainText = styled(Typography)({
  maxWidth: '95%',
  textAlign: 'center',
});
